import React from 'react'
import styled from '@emotion/styled';
import img from '../images/loading-gif.gif';

const LoadingContainer = styled.div`
    width:100%;
    height:100%;
    display:flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    top:0;
    left:0;
    background-color: rgba(2, 22, 1, 0.5);
    z-index: 1000000000000000000000000000000000;
    & > img{
        width:60px;
        height:60px;
        object-fit:contain;
    }
`
const Loading = () => {
  return (
    <LoadingContainer>
        <img src={img} alt={"Loading ..."} />
    </LoadingContainer>
  )
}

export default Loading